import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@material-ui/core'
import { KeyboardArrowRight, MoreVert } from '@material-ui/icons'
import SubmitterLog from 'assets/icons/GeneralLedger/submitter-log.svg'
import { DeleteDialog } from 'components/Dialog/DeleteDialog'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  useCancellationInvoiceAmortisationMutation,
  useDeleteInvoiceAmortisationMutation,
  useGetDocNumTitleQuery,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import {
  dateFormat,
  formatDate,
  formatTime,
} from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useContext, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'
import { InvoiceAmortisationCancelDialog } from '../InvoiceAmortisationComponent/InvoiceAmortisationCancelDialog'

/* -------------------------------------------- */
/*            For ACTIVE and APPROVED           */
/* -------------------------------------------- */
export const InvoiceAmortisationEntryList = (props: any) => {
  const {
    filteredList,
    listLoading,
    listStatus,
    userList,
    fetchMore,
    setOriginalListing,
    selectedField,
    sortOrder,
  } = props
  let history = useHistory()
  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  const refTable = 'AR_Amortisation'
  const { CompanyID }: any = useParams()

  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()

  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const [errDeleteDialog, setErrDeleteDialog] = useState(false)
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const [deleteJP, setDeleteJP] = useState(false)
  /** This is for permission purposes */
  const { handlePermDisabled } = usePermissionChecker()
  /**ACL */
  /* -------------------------------------------- */
  /*                    API                       */
  /* -------------------------------------------- */
  const {
    loading: docNumHeaderLoading,
    data: { getDocumentNumberHeader } = {
      getDocumentNumberHeader: [],
    },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID, RefTable: refTable },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    deleteInvoiceAmortisation,
    { loading: deleteInvoiceAmortisationLoading },
  ] = useDeleteInvoiceAmortisationMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.deleteRecord())
      setOriginalListing([])
      fetchMore({
        variables: {
          CompanyID,
          StatusArr: 'ACTIVE',
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name === '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
        },
      })
    },
  })
  const [
    cancellationInvoiceAmortisation,
    { loading: cancellationInvoiceAmortisationLoading },
  ] = useCancellationInvoiceAmortisationMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.deleteRecord())
      setOriginalListing([])
      fetchMore({
        variables: {
          CompanyID,
          StatusArr: 'COMPLETED',
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name === '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
        },
      })
    },
  })

  const handleDelete = data => {
    deleteInvoiceAmortisation({
      variables: { input: { AmortisationID: data } },
    })
    setDeleteJP(false)
  }

  const handleCancel = (amortisationID, remark) => {
    cancellationInvoiceAmortisation({
      variables: {
        AmortisationID: amortisationID,
        CompanyID: CompanyID,
        input: { CancellationRemark: remark },
      },
    })
    setCancelAmor(false)
  }

  const docNumChecker = getDocumentNumberHeader?.length === 0
  const [cancelAmor, setCancelAmor] = useState(false)

  return (
    <>
      {listLoading && <Loading />}
      {docNumHeaderLoading && <Loading />}
      {deleteInvoiceAmortisationLoading && <Loading />}
      {cancellationInvoiceAmortisationLoading && <Loading />}
      <ContentWrapper advSearch float overflow>
        <List className="core-list">
          {filteredList === undefined || filteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name !== '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                    sortField: selectedField === null ? null : selectedField,
                    sortOrder: sortOrder === null ? null : sortOrder,
                  },
                })
              }}
              hasMore={true}
              className=""
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              <>
                {filteredList
                  ?.filter(item => item.ApprovalStatus === listStatus)
                  ?.map((el, index) => {
                    const totalAmount = el.AmortisationItem.reduce(
                      (sum, item) => {
                        return (
                          sum +
                          item.AmortisationItemDetail.reduce(
                            (detailSum, detail) => detailSum + detail.Amount,
                            0
                          )
                        )
                      },
                      0
                    )
                    return (
                      <ListItem
                        style={{
                          textDecoration:
                            el?.ApprovalStatus === 'CANCELLED'
                              ? 'line-through'
                              : null,
                        }}
                        selected={el?.ApprovalStatus === 'CANCELLED'}
                      >
                        <ListItemText
                          primary={
                            <>
                              <span
                                className={`xsTitle flex-space`}
                                style={{ fontSize: '12px' }}
                              >
                                {el?.Invoice?.DocNo}
                              </span>
                              <span
                                className="desc"
                                style={{
                                  fontSize: '12px',
                                  color: 'black',
                                }}
                              >
                                <span className="">
                                  {dateFormat(el?.Invoice?.DocDate)}
                                </span>
                              </span>
                            </>
                          }
                          secondary={
                            <>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={12}>
                                  <span style={{ fontSize: '10px' }}>
                                    {el?.Invoice?.DebtorAccount?.DebtorName}
                                  </span>
                                </Grid>
                              </Grid>
                              <Grid
                                spacing={1}
                                container
                                className="table-content"
                              >
                                <Grid item xs={10}>
                                  {
                                    <div className="icon-text">
                                      <Tooltip
                                        disableFocusListener
                                        title={
                                          <Fragment>
                                            <Grid
                                              container
                                              wrap="nowrap"
                                              spacing={2}
                                            >
                                              <Grid item>
                                                <IconText
                                                  icon={
                                                    <img
                                                      src={SubmitterLog}
                                                      style={{
                                                        width: '12px',
                                                        marginRight: '3px',
                                                      }}
                                                    />
                                                  }
                                                  font="desc"
                                                />
                                              </Grid>
                                              <Grid item xs zeroMinWidth>
                                                <div
                                                  style={{ fontSize: '12px' }}
                                                >
                                                  {userList?.find(
                                                    x =>
                                                      x?.ID === el?.approvedBy
                                                  )?.name ??
                                                    userList?.find(
                                                      x =>
                                                        x?.ID === el?.createdBy
                                                    )?.name}
                                                </div>
                                                <div
                                                  style={{ fontSize: '10px' }}
                                                >
                                                  {formatDate(
                                                    el?.approvedTs ??
                                                      el?.createdTs
                                                  )}{' '}
                                                  &nbsp;
                                                  {formatTime(
                                                    el?.approvedTs ??
                                                      el?.createdTs
                                                  )}
                                                </div>
                                              </Grid>
                                            </Grid>
                                          </Fragment>
                                        }
                                        arrow
                                        enterTouchDelay={0}
                                      >
                                        <div>
                                          <IconText
                                            icon={
                                              <img
                                                src={SubmitterLog}
                                                style={{
                                                  width: '12px',
                                                  marginRight: '3px',
                                                }}
                                              />
                                            }
                                            font="desc"
                                          />
                                        </div>
                                      </Tooltip>
                                      <span
                                        className="desc text-noflow"
                                        style={{ display: 'contents' }}
                                      >
                                        {el?.Invoice?.Description}
                                      </span>
                                    </div>
                                  }
                                </Grid>
                                <Grid
                                  item
                                  xs={2}
                                  style={{ textAlign: 'right' }}
                                >
                                  <span className="xxTitle">
                                    <span className="c-orange">
                                      <span style={{ fontSize: '12px' }}>
                                        {amtStr(totalAmount)}
                                      </span>
                                    </span>
                                  </span>
                                </Grid>
                              </Grid>
                            </>
                          }
                        />
                        <ListItemSecondaryAction>
                          {listStatus === 'ACTIVE' ||
                          listStatus === 'REJECTED' ? (
                            <IconButton
                              edge="end"
                              aria-label="menu"
                              aria-controls="menu-list"
                              aria-haspopup="true"
                              onClick={e =>
                                handleClick(e, el?.AmortisationID, index, el)
                              }
                            >
                              <MoreVert />
                            </IconButton>
                          ) : listStatus === 'CANCELLED' ? (
                            <IconButton
                              edge="end"
                              aria-label="arrow"
                              disabled={handlePermDisabled({
                                companyID: CompanyID,
                                permEnum:
                                  AcctPermission.AccReceivableGenerateScheduledBillingView,
                              })}
                              onClick={() =>
                                history.push({
                                  pathname: `/account-receivable/${CompanyID}/invoice-amortisation/${el?.AmortisationID}/detail`,
                                  state: el,
                                })
                              }
                            >
                              <KeyboardArrowRight />
                            </IconButton>
                          ) : (
                            <IconButton
                              edge="end"
                              aria-label="menu"
                              aria-controls="menu-list"
                              aria-haspopup="true"
                              onClick={e =>
                                handleClick(e, el?.AmortisationID, index, el)
                              }
                            >
                              <MoreVert />
                            </IconButton>
                          )}
                        </ListItemSecondaryAction>
                      </ListItem>
                    )
                  })}
              </>
            </InfiniteScroll>
          )}
        </List>
        {listStatus === 'ACTIVE' && (
          <FloatButton
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.GeneralLedgerJournalProcessingCreate,
            })}
            onClick={() => {
              if (docNumChecker) {
                setOpenSnackBar(true)
                setSnackBarMsg(
                  'Please set up Amortisation Journal Document Numbering in GL Document Numbering.'
                )
              } else {
                history.push({
                  pathname: `/account-receivable/${CompanyID}/invoice-amortisation/add`,
                })
              }
            }}
          />
        )}
      </ContentWrapper>
      {listStatus === 'ACTIVE' ? (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.GeneralLedgerJournalProcessingUpdate,
            })}
            onClick={() => {
              history.push({
                pathname: `/account-receivable/${CompanyID}/invoice-amortisation/${menu?.obj?.AmortisationID}/edit`,
                state: menu?.obj,
              })
            }}
          >
            <span className="">Edit</span>
          </MenuItem>
          <MenuItem onClick={() => setDeleteJP(true)}>
            <span className="">Delete</span>
          </MenuItem>
        </Menu>
      ) : listStatus === 'COMPLETED' ? (
        <>
          <Menu
            id="menu-list"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            onClick={handleClose}
          >
            <MenuItem
              disabled={handlePermDisabled({
                companyID: CompanyID,
                permEnum: AcctPermission.GeneralLedgerJournalProcessingUpdate,
              })}
              onClick={() => {
                history.push({
                  pathname: `/account-receivable/${CompanyID}/invoice-amortisation/${menu?.obj?.AmortisationID}/detail`,
                  state: menu?.obj,
                })
              }}
            >
              <span className="">View</span>
            </MenuItem>
            <MenuItem
              onClick={() => setCancelAmor(true)}
              disabled={!menu?.obj?.AllowedCancel}
            >
              <span className="">Cancel</span>
            </MenuItem>
          </Menu>
        </>
      ) : (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          <MenuItem
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum: AcctPermission.GeneralLedgerJournalProcessingUpdate,
            })}
            onClick={() => {
              history.push({
                pathname: `/account-receivable/${CompanyID}/invoice-amortisation/${menu?.obj?.AmortisationID}/edit`,
                state: { ...menu?.obj, mode: 'resubmit' },
              })
            }}
          >
            <span className="">Resubmit</span>
          </MenuItem>
        </Menu>
      )}

      <InvoiceAmortisationCancelDialog
        ID={menu?.ID}
        openCancelDialog={cancelAmor}
        setOpenCancelDialog={setCancelAmor}
        title={'Cancel this Invoice Amortisation'}
        menu={menu?.obj}
        handleCancel={handleCancel}
        passID={menu.ID}
      />

      <DeleteDialog
        ID={menu?.ID}
        openDeleteDialog={deleteJP}
        setOpenDeleteDialog={setDeleteJP}
        title={'Invoice Amortisation'}
        menu={menu?.obj}
        handleDelete={handleDelete}
        passID={menu.ID}
      />

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />

      <ErrorDialog
        errorDia={errDeleteDialog}
        setErrorDia={setErrDeleteDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
        isBool
        onclick={() => {
          setErrDeleteDialog(false)
          window.location.reload()
        }}
      />
    </>
  )
}
